import React, { ReactNode } from 'react';
import { motion } from 'framer-motion';

interface DynamicListProps<T> {
  items: T[];
  renderItem: (item: T, index: number) => ReactNode;
  className?: string;
  itemClassName?: string;
  emptyMessage?: string;
}

function DynamicList<T>({
  items,
  renderItem,
  className = '',
  itemClassName = '',
  emptyMessage = 'No items found.',
}: DynamicListProps<T>) {
  if (items.length === 0) {
    return (
      <div className="col-span-full text-center text-gray-600 py-12">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className={className}>
      {items.map((item, index) => (
        <motion.div
          key={index}
          className={`h-full ${itemClassName}`}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
        >
          {renderItem(item, index)}
        </motion.div>
      ))}
    </div>
  );
}

export default DynamicList;
